/**
 * SP 端末保存フロー用のモジュールシングルトン。
 * useParallelPdfDownload と useRtCommonDialog の間で状態を共有する。
 * FormatEdit → RealtimeTransferCommonDialog へ props をバケツリレーせずに済む。
 */
import { ref } from 'vue'

/** PDF blob 取得中か否か */
const isPdfDownloading = ref(false)
/**
 * SP 端末保存フローが進行中か否か。
 * beginParallelPdfFetch (SP) で true、ダウンロード決済後に false。
 */
const isSpDownloadMode = ref(false)

export function usePdfDownloadState() {
  return { isPdfDownloading, isSpDownloadMode }
}
